module.exports = __webpack_public_path__ + "static/media/martinhendricks.67c0e68e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/martinhendricks.webp
// module id = 465
// module chunks = 0